module.exports = __webpack_public_path__ + "img/vaccination-colored.b7a16281.svg";